import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

export interface OrganizationUsageEntry {
  id: string;
  name: string | { [key: string]: string };
  workspaces: Record<string, { id: string; name: string | { [key: string]: string } }>;
}

@Component({
    selector: 'ts-algorithm-usage-detail',
    templateUrl: './usage-detail.component.html',
    styleUrls: ['./usage-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatCardModule]
})
export class AlgorithmUsageDetailComponent {
  @Input() organization!: OrganizationUsageEntry;
  @Input() language = 'en';

  /**
   * Resolves a name that can be either a string or a language dictionary.
   */
  resolveName(name: string | { [key: string]: string }): string {
    if (typeof name === 'string') {
      return name;
    }
    return name[this.language] ?? name['en'] ?? Object.values(name)[0] ?? '';
  }

  /**
   * Returns the list of workspaces as an array.
   */
  get workspaceList(): { id: string; name: string | { [key: string]: string } }[] {
    return Object.values(this.organization?.workspaces ?? {});
  }
}
